//obviously you wouldn't have these here.

import { DEVICE_TYPES, SYSTEMS } from 'config/deviceTypeConfig';
import { DeviceType, SystemType } from 'types/devices.types';

type Device = {
  device_type_id: number;
  system_type_id: number;
  device_type?: string;
  system_type?: string;
};

export function DeviceIsDeviceType(device: Device | null | undefined, type: DeviceType): boolean {
  if (!device) return false;
  if (typeof type === 'number') return device.device_type_id === type;
  if (typeof type === 'string') {
    if (DEVICE_TYPES[type]) {
      if (device.device_type_id === DEVICE_TYPES[type]) return true;
    }
    // Check string match if device.device_type exists
    if (device.device_type && device.device_type === type) return true;
  }
  return false;
}

export function DeviceIsSystemType(
  device: Device | null | undefined,
  systemType: SystemType,
): boolean {
  if (!device) return false;
  if (typeof systemType === 'number') return device.system_type_id === systemType;
  if (typeof systemType === 'string') {
    if (SYSTEMS[systemType]) {
      if (device.system_type_id === SYSTEMS[systemType]) return true;
    }
    // Check string match if device.system_type exists
    if (device.system_type && device.system_type === systemType) return true;
  }
  return false;
}
